module.exports = __webpack_public_path__ + "img/selected0-min.9c6a1f12.png";